import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, NgModule, OnInit, Renderer2 } from '@angular/core';
import { WINDOW } from '@app/common/app-tokens';
import { Utilities } from '@app/common/utilities';
import { ErrorTemplatesModule } from '@app/components/error-templates/error-templates.component';
import { TextPlaceholderModule } from '@app/components/text-placeholder/text-placeholder.component';
import { WidgetPlaceholderModule } from '@app/components/widget-placeholder/widget-placeholder.component';
import { LinkModule } from '@app/directives/link.directive';
import { MyLatestSitesService } from '@app/services/my-latest-sites.service';
import { SiteService } from '@app/services/site.service';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'app-my-latest-sites',
  templateUrl: './my-latest-sites.component.html',
  styleUrls: ['./my-latest-sites.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyLatestSitesComponent implements OnInit {

  @Input() itemsToShow = 6;
  myLatestSites$: Observable<any[]>;
  private errorSubject$ = new Subject();
  private endPointsErrorSubject$ = new Subject();
  loading = true;
  componentName = 'Your latest sites';

  constructor(
    private myRecentSitesService: MyLatestSitesService,
    private renderer: Renderer2,
    private siteService: SiteService,
    @Inject(WINDOW) private window: Window) { }

  ngOnInit() {

   this.myLatestSites$ = this.myRecentSitesService.getMyRecentSitesFromSP(0, 50)
      .pipe(map(result => {
        const groups = result?.value?.filter(item => {
          return item.template.name === 'GROUP';
        })
          .map(item => {
            item.EndPoints$ = this.siteService
              .getGroupEndpoints(item.groupId)
              .pipe(
                catchError(err => {
                  this.endPointsErrorSubject$.next(item);
                  return of(null);
                }));
            return item;
          });
        this.loading = false;
        return groups?.slice(0, this.itemsToShow);
      })),
      catchError(err => {
        this.loading = false;
        this.errorSubject$.next(err);
        return of(null);
      });
  }

  whenTouched(event: TouchEvent, site: any) {
    const e = event.currentTarget as HTMLElement;
    if (e.classList.contains('card-inner-container-touched')) {
      this.renderer.removeClass(e, 'card-inner-container-touched');
    } else {
      this.renderer.addClass(e, 'card-inner-container-touched');
      this.whenMouseEnter(site);
    }
  }

  removeTouched(event: TouchEvent, site: any) {
    const e = event.currentTarget as HTMLElement;
    this.window.setTimeout(() => {
      if (e.classList.contains('card-inner-container-touched')) {
        this.renderer.removeClass(e, 'card-inner-container-touched');
      }
    }, 1500);

  }

  whenMouseEnter(site: any) {
    site.Hovered = true;
  }

  getGroupLetters(title: any) {
    return Utilities.generateInitials(title);
  }
}
@NgModule({
  declarations: [MyLatestSitesComponent],
  exports: [MyLatestSitesComponent],
  imports: [
    CommonModule,
    ErrorTemplatesModule,
    TextPlaceholderModule,
    WidgetPlaceholderModule,
    LinkModule,
  ]
})
export class MyLatestSitesModule { }
